import { ActionTypes, IAction } from '../actions/types';

export interface IOrg {
   id: string;
   name: string;
   allow_geofilter: boolean;
   allow_datasharing: boolean;
   allow_portal_access: boolean;
   is_active: boolean;
}

export interface IOrgState {
   orgs: IOrg[] | null
   isLoading: Boolean
   loadError: boolean
}

const initialState: IOrgState = {
   orgs: null,
   isLoading: false,
   loadError: false
}

export default function orgs(state = initialState, action: IAction): IOrgState {
   switch (action.type) {
      case ActionTypes.CLEAR_ORGS:
         return {
            ...state,
            orgs: null,
            loadError: false,
         };
      case ActionTypes.ORGS_LOADING:
         return {
            ...state,
            isLoading: true,
            loadError: false,
         };
      case ActionTypes.ORGS_LOADED:
         return {
            ...state,
            isLoading: false,
            loadError: false,
            orgs: action.payload
         };
      case ActionTypes.ORGS_LOAD_FAILED:
         return {
            ...state,
            isLoading: false,
            loadError: true,
         };
      default:
         return state;
   }
}
